import { useAuth } from "@/shared/hooks";
import { useUserStats } from "./hooks/use-user-stats";
import { Loader } from "@/shared/ui";
import {
  UserInfoCard,
  StatsOverview,
  PerformanceCard,
  EmptyState,
  DeleteAccountCard,
} from "./components";

export function ProfilePage() {
  const { user, userData } = useAuth();
  const { data: stats, isLoading } = useUserStats(user?.uid);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (!user || !userData) {
    return null;
  }

  return (
    <div className="container max-w-4xl mx-auto px-4 py-8">
      <div className="space-y-6">
        <UserInfoCard user={user} memberSince={userData.createdAt} />
        <StatsOverview stats={stats} />
        <PerformanceCard stats={stats} />
        {stats && stats.totalGames === 0 && <EmptyState />}
        <DeleteAccountCard />
      </div>
    </div>
  );
}
